// extracted by mini-css-extract-plugin
export var pageTitle = "security-module--pageTitle--CG8wp";
export var sectionTitle = "security-module--sectionTitle--3dN5k";
export var technicalSection = "security-module--technicalSection--3RS--";
export var technicalList = "security-module--technicalList--36_Q2";
export var caution = "security-module--caution--zPCVx";
export var isoBoxSection = "security-module--isoBoxSection--23zaB";
export var isoBoxSection__container = "security-module--isoBoxSection__container--1ULzg";
export var isoBox = "security-module--isoBox--2gDKn";
export var isoBox__image = "security-module--isoBox__image--3CifL";
export var isoBox__text = "security-module--isoBox__text--2D7nM";